export const isMobileView = (): boolean => {
  return window.innerWidth <= 600;
};
